import { render, staticRenderFns } from "./BlockEditor.vue?vue&type=template&id=abb8b9f0&scoped=true&"
import script from "./BlockEditor.vue?vue&type=script&lang=js&"
export * from "./BlockEditor.vue?vue&type=script&lang=js&"
import style0 from "./BlockEditor.vue?vue&type=style&index=0&id=abb8b9f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb8b9f0",
  null
  
)

export default component.exports